import { PartnerSearchByBrResponse } from 'pco-product-service-internal-consumer';
import { formatDate } from '../../../../../utils/dateUtils';

export const getPartnerKey = (partner: PartnerSearchByBrResponse) =>
  partner.techId ?? partner.globalPartnerId ?? `${partner.fullName ?? ''}-${partner.mainDomicileCountry ?? ''}`;

export const getPartnerTitle = (partner: PartnerSearchByBrResponse) =>
  `${partner.fullName ?? 'Unknown partner'} (${partner.globalPartnerId ?? '-'})`;

export const getPartnerDescription = (partner: PartnerSearchByBrResponse) =>
  `DOB: ${formatDate(partner.dateOfOrigin)} | Domicile: ${partner.mainDomicileCountry ?? '-'}`;

export const getPartnerTypeLabel = (partnerType: string | undefined): string => {
  if (partnerType === 'PI' || partnerType === 'INDIVIDUAL_PARTNER') {
    return 'Private Individual';
  }

  if (partnerType === 'LE' || partnerType === 'LEGAL_PARTNER' || partnerType === 'LEGAL_ENTITY') {
    return 'Legal Entity';
  }

  return partnerType ?? '-';
};
